module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('strong', [_vm._v("Acknowledgments")])])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("This volume emerged from a workshop held in Cambridge, Massachusetts, organized by the National Bureau of Economic Research (NBER) on April 27, 2018. Funding for the workshop was provided by the National Science Foundation Science of Science and Innovation Policy Program (award #1745164). Funding for a preconference and the conference volume was provided by the Ewing Marion Kauffman Foundation through its support of entrepreneurship research at the NBER. The conference and volume would not have been possible without the support of Maryann Feldman, Josh Lerner, and Jim Poterba. Richard Freeman and William Kerr were invaluable in helping select the papers for the conference and providing helpful feedback to authors. We are also grateful to Helena Fitz-Patrick, Denis Healy, Alison Oaxaca, Rob Shannon, and especially Carl Beck for administrative and organizational support. We thank discussants Thomas Åstebro, Prithwiraj Choudhury, Patricia Cortes, Delia Furtado, Jennifer Hunt, Anne Le Brun, Sarah Turner, and Bruce Weinberg, as well as panelists Aman Verjee, Ben Waber, and David Weil, for insightful and provocative discussions and comments.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43d1490f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780226695761_07_ack.vue
// module id = 75
// module chunks = 0